import Vue from 'vue'
const Bus = new Vue()

/* 生产预定人员改变的消息 */
export function productBookPassengerChange (passengerEs, trBookFlag) {
  Bus.$emit('book-passenger-change', passengerEs, trBookFlag)
}

/* 消费预定人员改变的消息 */
export function consumeBookPassengerChange (changeBookPassenger) {
  Bus.$on('book-passenger-change', (passengerEs, trBookFlag) => {
    changeBookPassenger.call(this, passengerEs, trBookFlag)
  })
}

/* 生产新增或删除的头部筛选内容改变的消息 */
export function productAddOrDeleteTopFilterInfo (filterConditionType, filterCondition) {
  Bus.$emit('add-or-delete-top-filter-info', filterConditionType, filterCondition)
}

/* 消费新增或删除的头部筛选内容改变的消息 */
export function consumeAddOrDeleteTopFilterInfo (addOrDeleteTopFilterInfo) {
  Bus.$on('add-or-delete-top-filter-info', (filterConditionType, filterCondition) => {
    addOrDeleteTopFilterInfo.call(this, filterConditionType, filterCondition)
  })
}

/* 生产头部筛选主动移除筛选内容的消息 */
export function productRemoveTopFilterInfo (topFilterCondition) {
  Bus.$emit('remove-top-filter-info', topFilterCondition)
}

/* 消费头部筛选主动移除筛选内容的消息 */
export function consumeRemoveTopFilterInfo (removeFilterCondition) {
  Bus.$on('remove-top-filter-info', (topFilterCondition) => {
    removeFilterCondition.call(this, topFilterCondition)
  })
}

/* 生产酒店筛选条件改变的消息 */
export function productHotelFilterChange (hotelFilterList) {
  Bus.$emit('hotel-filter-change', hotelFilterList)
}

/* 消费酒店筛选条件改变的消息 */
export function consumeHotelFilterChange (getHotelFilterEs) {
  Bus.$on('hotel-filter-change', (hotelFilterList) => {
    getHotelFilterEs.call(this, hotelFilterList)
  })
}

/* 生产酒店商圈改变的消息 */
export function productHotelFacilityChange (hotelFacilityList) {
  Bus.$emit('hotel-facility-change', hotelFacilityList)
}

/* 消费酒店商圈改变的消息 */
export function consumeHotelFacilityChange (getHotelFacilityEs) {
  Bus.$on('hotel-facility-change', (hotelFacilityList) => {
    getHotelFacilityEs.call(this, hotelFacilityList)
  })
}

/* 生产webSocket的消息 */
export function productWebSocketMsg (webSocketMsg) {
  Bus.$emit('web_socket_msg', webSocketMsg)
}

/* 消费webSocket的消息 */
export function consumeWebSocketMsg (consumeWebSocketMsg) {
  Bus.$on('web_socket_msg', (webSocketMsg) => {
    consumeWebSocketMsg.call(this, webSocketMsg)
  })
}



// WEBPACK FOOTER //
// ./src/util/busUtil.js